import { render, staticRenderFns } from "./SideBarExtras.vue?vue&type=template&id=cbe988ee&"
import script from "./SideBarExtras.vue?vue&type=script&lang=js&"
export * from "./SideBarExtras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports